import { Button, Icon, Typography } from '@saviynt/design-system';
import { useNavigate } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { TOKENS } from '../../constants';

import './ManagePageHeader.css';

/**
 * @description Page header for the Agent Management view.
 * Renders a MachineIdentity icon, the localised "Agent Management" title, and a
 * "Policies" button that navigates to `/policies` via TanStack Router.
 *
 * @returns {React.JSX.Element} The page header with title and policies navigation button.
 */
export default function ManagePageHeader() {
  const navigate = useNavigate();

  return (
    <div className='ManagePageHeader'>
      <Typography kind='h1' color={TOKENS.CF_NEU_BLD} isNoWrap>
        <FormattedMessage
          id='MUpCPw'
          defaultMessage='AI Agent Management'
          description='Page header title'
        />
      </Typography>
      <Button
        kind='outlined'
        size='large'
        leftIcon={<Icon kind='Settings' />}
        onClick={() => navigate({ to: '/policies' })}>
        <FormattedMessage
          id='oJpLuK'
          defaultMessage='Rules'
          description='Button for policies'
        />
      </Button>
    </div>
  );
}
